import React, { useEffect, useState } from "react";
import { styled } from "@mui/system";
import config from "../../../config/constants/config";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";

const EnrolledMemberStyle = styled("section")(({ theme }) => ({
  margin: "20px 0",
  ".MuiTableCell-root": {
    border: "none",
    padding: "7px",
    fontSize: "1rem",
    color: "#000",
  },
  ".MuiTableRow-root": {
    verticalAlign: "baseline",
  },
  ".MuiTable-root": {
    width: "55%",
  },
  "&.AMERICAN-copay": {
    ".MuiTable-root th:nth-child(1)": {
      width: "60%",
    },
    ".MuiTable-root th:nth-child(2)": {
      width: "40%",
    },
    ".MuiTableRow-head th": {
      color: "#454d58",
      paddingBottom: 0,
      fontSize: 14,
      textAlign: "left",
      fontFamily: "Roboto",
      fontWeight: "normal",
      borderBottom: "none",
      zIndex: 0,
      letterSpacing: 1.12,
    },
  },
}));

const headings = [
  { id: "idcardField", label: "Benefit" },
  { id: "fieldValue", label: "Value" },
];

const Services: React.FC<{ data: any }> = ({ data }) => {
  const [services, setServices] = useState(data.services || []);

  useEffect(() => {
    setServices(data.services || []);
  }, [data]);

  return (
    <EnrolledMemberStyle className={`${config.APP_NAME}-copay`}>
      <TableContainer className={`${config.APP_NAME}-copay`} sx={{ maxHeight: 440 }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {headings.map((column) => (
                <TableCell sx={{ fontWeight: 500 }} key={column.id}>
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {services.map((row: any, index: number) => (
              <TableRow hover tabIndex={-1} key={row.id || index}>
                <TableCell>{row.idcardField}</TableCell>
                <TableCell>{row.fieldValue}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </EnrolledMemberStyle>
  );
};

export default Services;
